import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import Games from '../Games';

export default class MainButtonBar extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    const localeData = {
      x: 0,
      y: -12,
      size: 12,
      overSize: 12,
      originY: 0,
      lineSpacing: -2
    };
    if (gameData.game === Games.face) {
      localeData.x = 0;
      localeData.y = -17;
      localeData.size = 14;
      localeData.overSize = 14;
      localeData.originY = 0.5;
    }
    if (gameData.game === Games.gingerbread || gameData.game === Games.pumpkin || gameData.game === Games.snowman) {
      localeData.x = 0;
      localeData.y = -16;
      localeData.size = 14;
      localeData.overSize = 14;
      localeData.originY = 0.5;
      localeData.lineSpacing = -4;
    }

    this.btnUndo = this.scene.add.container(0, 0);
    const undoBG = ABCyaPhaser.Images.addImage(0, 0,'BtnUndo', this.btnUndo).setOrigin(0);
    ABCyaPhaser.Container.setContainerInteractive(this.btnUndo, true);
    this.btnUndo.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleUndo, this);
    const undoText = ABCyaPhaser.Text.addText(undoBG.width / 2 + localeData.x, undoBG.height + localeData.y, localeData.size, 0xFFFFFF, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('buttons.undo'), this.btnUndo, true).setResolution(2)
      .setOrigin(0.5, localeData.originY);
    this.add(this.btnUndo);

    this.btnStartOver = this.scene.add.container(this.btnUndo.x + this.btnUndo.getBounds().width + 10, 0);
    const startOverBG = ABCyaPhaser.Images.addImage(0, 0,'BtnStartOver', this.btnStartOver).setOrigin(0);
    ABCyaPhaser.Container.setContainerInteractive(this.btnStartOver, true);
    this.btnStartOver.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleStartOver, this);
    const startOverText = ABCyaPhaser.Text.addText(startOverBG.width / 2 + localeData.x, startOverBG.height + localeData.y, localeData.overSize, 0xFFFFFF, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('buttons.start_over'), this.btnStartOver, true).setResolution(2)
      .setWordWrapWidth(75)
      .setLineSpacing(localeData.lineSpacing)
      .setOrigin(0.5, localeData.originY);
    this.add(this.btnStartOver);

    this.btnSave = this.scene.add.container(this.btnStartOver.x + this.btnStartOver.getBounds().width + 10, 0);
    const saveBG = ABCyaPhaser.Images.addImage(0, 0,'BtnSave', this.btnSave).setOrigin(0);
    ABCyaPhaser.Container.setContainerInteractive(this.btnSave, true);
    this.btnSave.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleSave, this);
    const saveText = ABCyaPhaser.Text.addText(saveBG.width / 2 + localeData.x, saveBG.height + localeData.y, localeData.size, 0xFFFFFF, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('buttons.save'), this.btnSave, true).setResolution(2)
      .setOrigin(0.5, localeData.originY);
    this.add(this.btnSave);

  }

  handleSave () {
    this.emit('SAVE_PICTURE');
  }

  handleUndo () {
    this.emit('UNDO');
  }

  handleStartOver () {
    this.emit('START_OVER');
  }
}